<template>
    <div>
        <div
            class="tw-flex tw-justify-center tw-pt-[80px] tw-pb-[80px] tw-px-3"
        >
            <div class="tw-w-full">
                <div class="tw-flex tw-justify-center tw-items-center tw-py-3">
                    <van-image
                        lazy-load
                        class="tw-w-6/12 lg:tw-w-3/12 md:tw-w-3/12 sm:tw-w-4/12"
                        :src="
                            require('../../../assets/landing/img/google-login-callback-cover.png')
                        "
                    />
                </div>

                <div class="tw-mb-3">
                    <p class="tw-text-center tw-text-gray-600">
                        Login with your Google account to continue.
                    </p>
                </div>

                <div
                    class="tw-flex tw-justify-center tw-items-center tw-mb-3"
                    v-if="errorMessage != null"
                >
                    <i
                        class="fas fa-exclamation-triangle tw-text-red-500 tw-text-md tw-ml-2 tw-mr-2"
                    ></i>
                    <span
                        class="tw-text-sm tw-text-red-600"
                        v-text="errorMessage"
                    ></span>
                </div>

                <div class="tw-flex tw-justify-center tw-my-4">
                    <van-button
                        type="default"
                        color="#1361b4"
                        loading-text="Loading..."
                        :loading="btnLoading"
                        @click="onContinue"
                    >
                        Continue
                    </van-button>
                </div>
            </div>
        </div>

        <Copyright></Copyright>
    </div>
</template>

<script>
import { loginWithGoogle } from "@landing/Services/auth_service";
import Copyright from "@landing/Components/Copyright.vue";

export default {
    components: {
        Copyright,
    },
    data() {
        return {
            btnLoading: false,
            errorMessage: null,
        };
    },
    mounted() {},
    methods: {
        onContinue() {
            this.btnLoading = true;
            this.errorMessage = null;

            const access_token = new URLSearchParams(
                window.location.hash.substring(1)
            ).get("access_token");

            loginWithGoogle({ access_token: access_token }).then((data) => {
                if (data.status == 200) {
                    if (data.data.result == 1) {
                        Vue.$toast.success(data.data.message);

                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    } else {
                        this.errorMessage = data.data.message;
                    }
                } else if (data.status == 422) {
                    this.errorMessage = data.data.message;
                } else {
                    this.errorMessage = "Oops! Something went wrong.";
                }

                setTimeout(() => {
                    this.btnLoading = false;
                }, 500);
            });
        },
    },
};
</script>
